module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-shirt-58fe6536538ee4dad07a5edc74bdb269.svg";